// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1-_Ah","colCheckbox":"styles_colCheckbox__3qvaZ"};